import { render, staticRenderFns } from "./WorldEdit.vue?vue&type=template&id=ca3f82da&scoped=true&"
import script from "./WorldEdit.vue?vue&type=script&lang=js&"
export * from "./WorldEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3f82da",
  null
  
)

export default component.exports